"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TEXT_COLOR = void 0;
/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/rules-of-hooks */
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const measurements_1 = require("../../utilities/measurements");
const Axis_1 = __importStar(require("../Axis"));
const LabelContainer_1 = __importDefault(require("../LabelContainer"));
exports.DEFAULT_TEXT_COLOR = '#4D4D4D';
const SCALE_FONT_OFFSET_RATIO = 1.5;
const Scale = _ref => {
  let {
    colorScale = colors_1.DIVERGING_COLOR_RANGES['yellow-teal-9-bin'],
    values = [],
    fontSize = constants_1.DEFAULT_FONT_SIZE,
    fontColor,
    width = 300,
    height = 10,
    x,
    y,
    formatter = value => value,
    showNoData = false,
    noDataColor = 'usa-gray',
    onClick = () => {},
    onMouseOver = () => {},
    onMouseMove = () => {},
    onMouseOut = () => {}
  } = _ref;
  if (values.length < 2 || colorScale.length < 1 || x === undefined || y === undefined) {
    return null;
  }
  const sortedValues = lodash_1.default.sortBy(values).slice(0, colorScale.length + 1);
  const minimum = sortedValues[0];
  const maximum = sortedValues[sortedValues.length - 1];
  const textColor = (0, colors_1.parseColor)(fontColor, exports.DEFAULT_TEXT_COLOR);
  const numSegments = Math.min(colorScale.length && sortedValues.length - 1);
  const textWidth = showNoData ? (0, measurements_1.textDimensions)({
    text: 'NO DATA',
    fontSize,
    fontFamily: constants_1.FONT_FAMILY
  }).width + fontSize / SCALE_FONT_OFFSET_RATIO : 0;
  const noDataWidth = showNoData ? (width - textWidth) / (numSegments + 1) : 0;
  const spacer = x + textWidth + noDataWidth;
  const availableWidth = width - textWidth - noDataWidth;
  const ticks = sortedValues.map(value => ({
    data: value,
    point: spacer + availableWidth * (value - minimum) / (maximum - minimum)
  }));
  const segments = sortedValues.map((value, i) => {
    if (i < colorScale.length && i < sortedValues.length - 1) {
      const x1 = spacer + availableWidth * (value - minimum) / (maximum - minimum);
      const x2 = spacer + availableWidth * (sortedValues[i + 1] - minimum) / (maximum - minimum);
      return {
        key: i,
        value,
        color: (0, colors_1.parseColor)(colorScale[i], 'usa-gray'),
        x1,
        x2,
        y,
        opacity: 1,
        height
      };
    }
    return undefined;
  }).filter(segment => segment !== undefined);
  const noDataLabel = showNoData ? [{
    x,
    y: y + constants_1.FONT_VERTICAL_CENTER_OFFSET_RATIO * fontSize,
    content: 'NO DATA',
    style: {
      fontSize,
      fill: textColor,
      fontWeight: Axis_1.DEFAULT_FONT_WEIGHT
    }
  }] : undefined;
  if (showNoData) {
    segments.unshift({
      value: '',
      color: (0, colors_1.parseColor)(noDataColor, 'usa-gray'),
      x1: x + textWidth,
      x2: x + textWidth + noDataWidth / 2,
      y,
      opacity: 1,
      height,
      key: 'no data'
    });
  }
  return react_1.default.createElement("g", {
    className: "scale"
  }, noDataLabel && react_1.default.createElement(LabelContainer_1.default, {
    labels: noDataLabel
  }), segments.map((item, i) => {
    const {
      x1,
      x2,
      color,
      y,
      height
    } = item;
    return react_1.default.createElement("line", {
      key: `segment-${i}`,
      stroke: color,
      strokeWidth: height,
      x1: x1,
      y1: y,
      x2: x2,
      y2: y,
      onMouseOver: event => onMouseOver(event, item),
      onMouseMove: event => onMouseMove(event, item),
      onMouseOut: event => onMouseOut(event, item),
      onClick: event => onClick(event, item)
    });
  }), react_1.default.createElement(Axis_1.default, {
    position: "bottom",
    chartHeight: y - height / 2 - fontSize / SCALE_FONT_OFFSET_RATIO,
    chartWidth: width,
    ticks: ticks,
    formatter: formatter,
    fontSize: fontSize,
    textColor: textColor
  }));
};
Scale.propTypes = {
  /**
   * Colors for each section of the scale.
   */
  colorScale: (0, prop_types_1.arrayOf)(prop_types_1.string).isRequired,
  /**
   * Values for the scale. If these are not in ascending order,
   * they will be sorted automatically. If the number of values
   * exceeds the number of available colors by more than 1,
   * the highest values will be removed. Must contain at least two values.
   */
  values: (0, prop_types_1.arrayOf)(prop_types_1.number).isRequired,
  /**
   * Font size for scale labels.
   */
  fontSize: prop_types_1.number,
  /**
   * Font color for scale labels.'
   */
  fontColor: prop_types_1.string,
  /**
   * Width of the scale in px.
   */
  width: prop_types_1.number,
  /**
   * Height for the scale in px.
   */
  height: prop_types_1.number,
  /**
   * X coordinate for the scale.
   */
  x: prop_types_1.number.isRequired,
  /**
   * Y coordinate for the scale.
   */
  y: prop_types_1.number.isRequired,
  /**
   * Formatter for scale labels.
   */
  formatter: prop_types_1.func,
  /**
   * Show/hide a 'NO DATA' indicator on the left of the scale.
   */
  showNoData: prop_types_1.bool,
  /**
   * Sets color for the 'NO DATA' indicator.
   */
  noDataColor: prop_types_1.string,
  /**
   * function to activate on click
   * parameters: (event, item)
   */
  onClick: prop_types_1.func,
  /**
   * function to activate on mouseOver
   * parameters: (event, item)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseMove
   * parameters: (event, item)
   */
  onMouseMove: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, item)
   */
  onMouseOut: prop_types_1.func
};
exports.default = Scale;